import TextInputState from "../TextInputState/index";
const dismissKeyboard = () => {
  TextInputState.blurTextInput(TextInputState.currentlyFocusedField());
};
var dismissKeyboard_default = dismissKeyboard;
export {
  dismissKeyboard_default as default
};
//# sourceMappingURL=index.js.map
